<template>
    <div class="p-4">

        <template v-if="q_status == 'completed'">
            
            <!-- Gift Card -->
            <div class="gift-card-wrap">
                <div class="alert-msg-wrap mb-4">
                    <p>{{ alert_msg }}</p>
                    <img v-if="alert_img" :src="alert_img">
                </div>

                <form @submit.prevent="redeem_gift_card" v-if="showRedeemGift">
                    <template v-if="isListLoading">
                        <div class="skeleton-progress progress m-auto" style="width: 16em; height: 10em;">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                        </div>
                        <div class="skeleton-progress progress mt-3" style="width: 100%; height: 4em;">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                        </div>
                        <div class="skeleton-progress progress" style="width: 100%; height: 4em;">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="text-center">
                                    <img :src="model.gift_card.faceplate" class="faceplate">
                                </div>
                                <h2 class="mt-2">${{ model.gift_card.amount }} {{ model.gift_card.currency }} {{ model.gift_card.name }}</h2>
                            </div>
                        </div>
                        <div class="row mt-2 custom-gutter">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Firstname" ref="firstname" v-model="model.firstname" required>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Lastname" ref="lastname" v-model="model.lastname" required>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <input type="email" class="form-control" placeholder="Email address" ref="email" v-model="model.email" required>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <button class="btn btn-black" type="submit" :disabled="isSubmitting">
                                <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                                <template v-else>Redeem</template>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <!-- End -->

        </template>

        <template v-else-if="q_status && q_status != 'completed'">
            <div class="alert-msg-wrap mb-4">
                <p>{{ alert_msg }}</p>
                <img v-if="alert_img" :src="alert_img">
            </div>
        </template>

        <template v-else>

            <!-- Questionnaire -->
            <form @submit.prevent="submit_questionnaire">
                <div class="surveys_wrap">
                    <div class="table-responsive">
                        <table class="surveys_table">
                            <thead class="xs-hide">
                                <th>Case #</th>
                                <th>Job Name</th>
                                <th>Do you have the job?</th>
                                <th>Project Awarded to Torin Drive North America?</th>
                                <th>Reason Job was not Awarded to TDNA</th>
                            </thead>
                            <tbody>
                                <tr v-for="(row, key) in surveys" :class="{ 'survey': row.status != 'CLOSED' }" :key="key">
                                    <td class="xs-th" style="word-break: break-all;">
                                        <div>Case #: {{ row.quote_number }}</div>
                                        <div>Job Name: {{ row.project_name }}</div>
                                    </td>
                                    <td style="width: 20%; word-break: break-all;" class="quote_number text-center xs-hide">{{ row.quote_number }}</td>
                                    <td style="width: 20%; word-break: break-all;" class="project_name text-center xs-hide">{{ row.project_name }}</td>
                                    <template v-if="row.status == 'CLOSED'">
                                        <td class="text-center" colspan="3">CLOSED</td>
                                    </template>
                                    <template v-else>
                                        <td class="xs-th question_1_th">Do you have the job?</td>
                                        <td style="width: 18%;" class="question_1 text-center">
                                            <div class="answer_wrap">
                                                <label><input type="radio" class="answer" :ref="'project_awarded'+key+'1'" :name="'project_awarded'+key" @click="row.awarded_to_ses = ''; row.job_lost_reason = ''; row.job_lost_reason_specify = '';" required value="won" v-model="row.project_awarded"><span>Won</span></label>
                                                <label><input type="radio" class="answer" :ref="'project_awarded'+key+'2'" :name="'project_awarded'+key" @click="row.awarded_to_ses = ''; row.job_lost_reason = ''; row.job_lost_reason_specify = '';" required value="lost" v-model="row.project_awarded"><span>Lost</span></label>
                                                <label><input type="radio" class="answer" :ref="'project_awarded'+key+'3'" :name="'project_awarded'+key" @click="row.awarded_to_ses = ''; row.job_lost_reason = ''; row.job_lost_reason_specify = '';" required value="pending" v-model="row.project_awarded"><span>Pending</span></label>
                                            </div>
                                        </td>
                                        
                                        <td class="xs-th question_2_th">
                                            <div v-if="row.project_awarded != 'won'" class="cover"></div>
                                            Project Awarded to Torin Drive North America?
                                        </td>

                                        <td style="width: 16%;" class="question_2 text-center">
                                            <template v-if="row.project_awarded == 'won'">
                                                <div v-show="row.project_awarded == 'won'" class="answer_wrap">
                                                    <label><input type="radio" class="answer" :name="'awarded_to_ses'+key" @click="row.job_lost_reason = ''; row.job_lost_reason_specify = '';" required value="yes" v-model="row.awarded_to_ses"><span>Yes</span></label>
                                                    <label><input type="radio" class="answer" :name="'awarded_to_ses'+key" @click="row.job_lost_reason = ''; row.job_lost_reason_specify = '';" required value="no" v-model="row.awarded_to_ses"><span>No</span></label>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="cover"></div>
                                                <div class="answer_wrap">
                                                    <label><input type="radio" class="answer" disabled><span>Yes</span></label>
                                                    <label><input type="radio" class="answer" disabled><span>No</span></label>
                                                </div>
                                            </template>
                                        </td>

                                        <td class="xs-th question_3_th">
                                            <div v-if="row.project_awarded != 'won' || row.awarded_to_ses != 'no'" class="cover"></div>
                                            Reason Job was not Awarded to SES
                                        </td>

                                        <td style="width: 26%;" class="question_3">
                                            <template v-if="row.project_awarded == 'won' && row.awarded_to_ses == 'no'">
                                                <div class="reason_wrap">
                                                    <div class="answer_wrap">
                                                        <label><input type="radio" class="answer" :name="'job_lost_reason'+key" required value="Consultant Spec." v-model="row.job_lost_reason"><span>Consultant Spec.</span></label>
                                                        <label><input type="radio" class="answer" :name="'job_lost_reason'+key" required value="Pricing" v-model="row.job_lost_reason"><span>Pricing</span></label>
                                                    </div>
                                                    <div class="answer_wrap">
                                                        <label><input type="radio" class="answer" :name="'job_lost_reason'+key" required value="Product Fit" v-model="row.job_lost_reason"><span>Product Fit</span></label>
                                                        <label class="others_wrap">
                                                            <input type="radio" class="answer" :ref="'other'+key" :name="'job_lost_reason'+key" required value="Other" v-model="row.job_lost_reason"><span>Other</span>
                                                            <template v-if="row.job_lost_reason == 'Other'">
                                                                <input type="text" class="other" placeholder="Specify" v-model="row.job_lost_reason_specify" required focus>
                                                            </template>
                                                            <template v-else>
                                                                <input type="text" class="other" @click="specify(key)" v-model="row.job_lost_reason_specify" placeholder="Specify">
                                                            </template>
                                                        </label>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="cover"></div>
                                                <div class="reason_wrap">
                                                    <div class="answer_wrap">
                                                        <label><input type="radio" class="answer" disabled><span>Consultant Spec.</span></label>
                                                        <label><input type="radio" class="answer" disabled><span>Pricing</span></label>
                                                    </div>
                                                    <div class="answer_wrap">
                                                        <label><input type="radio" class="answer" disabled><span>Product Fit</span></label>
                                                        <label class="others_wrap">
                                                            <input type="radio" class="answer" disabled><span>Other</span>
                                                            <input type="text" class="other" placeholder="Specify" disabled>
                                                        </label>
                                                    </div>
                                                </div>
                                            </template>
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                        <template v-if="surveys.length == 0 && !isListLoading">
                            <p class="no-results-msg">No results found</p>
                        </template>
                        <template v-if="isListLoading">
                            <div class="progress">
                                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                            </div>
                        </template>
                    </div>
                    <div class="btn_footer_wrap">
                        <button class="btn btn-primary" type="submit" :disabled="isSubmitting">
                            <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                            <template v-else>Submit</template>
                        </button>
                    </div>
                </div>
            </form>
            <!-- End -->

        </template>

    </div>
</template>
<script>
export default {
    data() {
        return {
            isListLoading: false,
            isSubmitting: false,
            showRedeemGift: false,
            q_status: false,
            alert_msg: '',
            alert_img: '',
            s_id: null,
            selected: null,
            surveys: [],
            model: {
                action: 'final',
                s_id: null,
                firstname: '',
                lastname: '',
                email: '',
                client_id: '',
                batch_code: '',
                gift_card: {
                    faceplate: '',
                    name: '',
                    amount: '',
                    currency: ''
                }
            }
        }
    },
    mounted() {
        let queryString = window.location.search
        let urlParams = new URLSearchParams(queryString)
        this.s_id = urlParams.get('s_id')
        this.selected = urlParams.get('selected')
        this.get_surveys().then(() => {
            if(this.selected) {
                this.$refs[`project_awarded${this.selected}`][0].click()
            }
        })        
    },
    methods: {
        get_surveys() {
            this.isListLoading = true
            return this.$http.post('/api/follow-up-emails/questionnaires', { s_id: this.s_id })
                .then((response) => {
                    this.surveys = response.data.data
                    this.isListLoading = false
                })
                .catch((error) => {
                    this.q_status = error.response.data.message

                    if(this.q_status == 'completed') {
                        this.model.batch_code = error.response.data.batch_code
                        this.model.client_id = error.response.data.client_id
                        this.model.gift_card = error.response.data.gift_card
                        this.model.action = error.response.data.action
                        this.alert_msg = error.response.data.success_msg
                        this.alert_img = error.response.data.success_img
                    } else if(this.q_status == 'redeemed') {
                        this.alert_msg = error.response.data.success_msg
                        this.alert_img = error.response.data.success_img
                    } else {
                        this.alert_msg = error.response.data.error
                        this.alert_img = ''
                    }

                    this.isListLoading = false
                })
        },
        submit_questionnaire() {
            this.isSubmitting = true
            return this.$http.post('/api/follow-up-emails/questionnaires/save', { surveys: this.surveys })
                .then(() => {
                    this.isSubmitting = false
                    this.get_surveys()
                })
                .catch((error) => {
                    if(error.response.data.message == 'failed') {
                        alert('Something went wrong! Please contact the administrator. Thank you.')
                    } else {
                        alert(error.response.data.error)
                    }
                    this.isSubmitting = false
                })
        },
        redeem_gift_card() {
            this.isSubmitting = true
            this.model.s_id = this.s_id

            this.$http.post('/api/follow-up-emails/redeem', this.model)
                .then((response) => {
                    this.isSubmitting = false
                    this.q_status = 'redeemed_success'
                    this.alert_msg = response.data.success_msg
                    this.alert_img = response.data.success_img
                })
                .catch(() => {
                    alert('Something went wrong! Please contact the administrator. Thank you.')
                    this.isSubmitting = false
                })
        },
        specify(key) {
            this.$refs[`other${key}`][0].click()
        }
    }
}
</script>
<style lang="scss" scoped>
.progress {
    border-radius: 0;
}
.no-results-msg {
    text-align: center;
    padding: 0.5em;
    font-size: 11px;
}
.surveys_table {
    width: 100%;
    border-collapse: collapse;
}
.surveys_table th {
    background: #323232;
    color: #fff;
    text-align: center;
    border: 0;
    font-size: 12px;
    text-transform: uppercase;
    padding: 0.5em 1em;
    vertical-align: center;
}
.surveys_table td {
    border: 0;
    vertical-align: center;
    font-size: 12px !important;
    text-align: left;
    padding: 0.5em 1em !important;
    position: relative;
}
.surveys_table th:not(:last-child), .surveys_table td:not(:last-child) {
    border-right: 1px solid #000;
}
.surveys_table tr:nth-child(odd) {
    background: #f6f6f6;
}
.surveys_table tr:nth-child(even) {
    background: #dedede;
}
.answer_wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}
.answer_wrap input[type=radio] {
    margin: 0 4px 0 0;
    padding: 0;
}
.answer_wrap label {
    display: flex;
    align-items: center;
    font-weight: normal;
    margin: 0 14px 0 0;
    padding: 0;
}
.answer_wrap label:last-child {
    margin-right: 0;
}
.answer_wrap span {
    line-height: 1;
    margin-top: 1pt;
}
.question_1 .answer_wrap {
    max-width: 200px;
    justify-content: space-between;
}
.question_2 .answer_wrap {
    max-width: 100px;
    justify-content: space-between;
}
.question_3 .answer_wrap {
    justify-content: flex-start;
}
.question_3 .answer_wrap label {
    min-width: 110px;
    height: 24px;
}
.reason_wrap {
    margin: 0 auto;
    max-width: 300px;
}
.others_wrap {
    display: flex;
    align-items: center;
}
.others_wrap .other {
    min-width: 100px;
    margin-left: 0.2em;
    font-size: 12px !important;
    padding: 0.2em 0.4em !important;
    height: 22px !important;
}
.cover {
    background: #f6f6f6;
    position: absolute; 
    top: 0; 
    left: 0; 
    height: 100%; 
    width: 100%;
    z-index: 999;
    opacity: 0.7;
}
.cover.open {
    display: none;
}
.table-responsive {
    overflow-x: auto;
}
.btn_footer_wrap {
    text-align: right;
    margin-top: 1em;
}
.xs-th {
    display: none;
}
.xs-show {
    display: none;
}
@media (max-width: 720px) {
    .surveys_table th, 
    .surveys_table td,
    .answer_wrap label,
    .others_wrap .other {
        font-size: 11px !important;
    }
}
@media (max-width: 992px) {
    .question_3 .answer_wrap {
        display: block;
    }
}
@media (max-width: 620px) {
    .xs-hide {
        display: none !important;
    }
    .xs-show {
        display: block;
    }
    .surveys_table td {
        display: block;
        width: 100% !important;
        border: 0 !important;
    }
    td.xs-th {
        display: block;
        text-transform: uppercase;
        background: #323232;
        color: #fff;
    }
    td.xs-th.question_1_th,
    td.xs-th.question_2_th,
    td.xs-th.question_3_th {
        font-weight: bold;
        background: none;
        color: #000;
    }
    td.xs-th.question_2_th,
    td.xs-th.question_3_th {
        padding-top: 1em !important;
    }
    td.question_3 {
        padding-top: 0 !important;
        padding-bottom: 1em !important;
    }
    .question_1 .answer_wrap {
        max-width: 260px;
    }
    .question_2 .answer_wrap {
        max-width: 260px;
        justify-content: flex-start;
    }
    .question_2 .answer_wrap label {
        min-width: 87px;
    }
    .question_3 .answer_wrap {
        display: flex !important;
    }
    .others_wrap .other {
        min-width: 88px;
    }
    .reason_wrap {
        max-width: 260px;
    }
}
@media (max-width: 300px) {
    .question_3 .answer_wrap {
        display: block !important;
    }
}

.gift-card-wrap {
    max-width: 480px;
    width: 100%;
    margin: 0 auto;
    .form-control {
        &::placeholder {
            color: #808080;
            opacity: 1;
        }
    }
    .custom-gutter > [class*='col-'] {
        padding-right: 8px;
        padding-left: 8px;
        &:first-child {
            padding-left: 15px;
        }
        &:last-child {
            padding-right: 15px;
        }
    }
}
@media (max-width: 768px) {
    .gift-card-wrap {
        .custom-gutter > [class*='col-'] {
            padding-right: 15px;
            padding-left: 15px;
        }
    }
}
.alert-msg-wrap {
    max-width: 992px;
    margin: 0 auto;
    text-align: center;
    img {
        margin-top: 0.5em;
        max-width: 420px;
        width: 100%;
    }
}
@media (max-width: 480px) {
    .alert-msg-wrap {
        p {
            text-align: left;
        }
    }
}
</style>